import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Textarea,
} from "@chakra-ui/react";

import EmployeeDataService from "../../services/Employee";
import { useState, useEffect } from "react";

export const EmployeeLeavesRemarkModal = ({
  isOpen,
  onClose,
  id,
  func,
  existingNote,
}: any) => {
  const [note, setNote] = useState("");

  useEffect(() => {
    setNote(existingNote || "");
  }, [existingNote]);

  const handleDeleteNote = () => {
    EmployeeDataService.deleteNote(id)
      .then(() => {
        func();
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  
  const handleAddEditNote = () => {
    const noteData = { note };
    EmployeeDataService.addEditNote(id, noteData)
      .then((response: any) => {
        func();
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{existingNote ? "Edit Remark" : "Add Remark"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Textarea
            placeholder="Enter the remark here..."
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            bgColor="#327171"
            color="white"
            mr={3}
            onClick={handleAddEditNote}
          >
            {existingNote ? "Update" : "Add"}
          </Button>
          {existingNote && (
            <Button
              bgColor="red"
              color="white"
              mr={3}
              onClick={handleDeleteNote}
            >
              Delete
            </Button>
          )}
          <Button bgColor="gray" color="white" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
